import { useMemo } from 'react';

import { BootstrapTable } from '@components/Table/Table';

export const DidGroupTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        className: 'col-md-3',
      },
      {
        Header: '# Shared channels',
        accessor: 'channel_amount',
        className: 'col-md-2',
      },
      {
        Header: 'Max Shared channels',
        accessor: 'max_shared_channels',
        className: 'col-md-2',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      tableHeader="Did Group"
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, bordered: true })}
    />
  );
};

export const DidGroupDidsTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'DIDs in DID Group',
        accessor: 'did',
      },
    ],
    []
  );
  return (
    <div style={{ overflowY: 'scroll', height: '350px' }}>
      <BootstrapTable
        columns={columns}
        data={data}
        tableProps={() => ({
          responsive: true,
          bordered: true,
        })}
      />
    </div>
  );
};
